import { stringify } from 'querystring';

export default function pathWithQueryString(
  path: string,
  parsedUrlQuery: Record<string, string | string[] | number | undefined>
): string {
  const filteredParams = Object.entries(parsedUrlQuery).filter(
    ([, value]) =>
      value !== undefined &&
      (typeof value === 'string' || typeof value === 'number')
  );
  const params = Object.fromEntries(filteredParams);

  const query = stringify(params);

  if (!query) return path;

  return `${path}?${query}`;
}
